(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('SymptomSearch', SymptomSearch);

    SymptomSearch.$inject = ['$resource'];

    function SymptomSearch($resource) {
        var resourceUrl =  'api/_search/symptoms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
